<template>
  <van-row class="dealerInfoBox">
    <van-col :span="colLabelSpanCom"
      ><span class="colLabel">
        <slot name="colLabel">选择经销商</slot>
      </span></van-col
    >
    <van-col :span="colValSpan">
      <!-- 经销商名称 -->
      <div class="fvlr" @click="changeShowNUm">
        <div v-if="dealer.name" class="dealerName ellipsis">
          <slot name="currentDealer">{{ dealer.name }}</slot>
        </div>
        <div v-else class="noDealer">
          <slot name="noDealer">请选择经销商</slot>
        </div>
        <van-icon name="arrow" v-if="!dealerFreezeFlag && !isOtrOrderNo" />
      </div>
      <!-- 经销商地址 -->
      <div class="fvlr" v-if="dealer.name">
        <slot name="afterName">
          <div class="dealerLocationBox" @click="changeShowNUm">
            <p class="dealerLocation">
              {{ dealer.address }}
            </p>
            <div>
              <span v-if="from === 'tyre'">
                <span class="salesVolume">销量：{{ dealer.sales }}</span>
                &nbsp;&nbsp;|&nbsp;&nbsp;
              </span>
              <span v-else-if="from === 'coupon'">
                <span :class="{ circle: true, circleActive: joinCouponFlag }"> {{ joinCouponFlag ? '' : '未' }}参加活动 </span>
              </span>
              <span v-else-if="from === 'shopDetail' || from === 'ewShopDetail'"> </span>
              <span
                v-else
                class="circle"
                :class="{
                  circleActive: dealer.joinPlanFlag || dealerJoinPlanFlag
                }"
              >
                {{ dealer.joinPlanFlag || dealerJoinPlanFlag ? '' : '未' }}参加活动
              </span>
              <span class="dealerLocation">{{ dealer.distance || dealer.distance === 0 ? '距您约' + dealer.distance + 'km' : '定位失败' }}</span>
            </div>
          </div>
          <a :href="`tel:${dealer.tel}`">
            <van-icon class="phone" name="phone" />
          </a>
        </slot>
      </div>
    </van-col>
  </van-row>
  <teleport to="#dialog">
    <SwitchDealer :from="from" :isShowPhone="isShowPhone" :showNum="showNum" @dealerFn="dealerFn" />
  </teleport>
</template>

<script>
import { reactive, toRefs, onMounted, watch, onUnmounted, computed } from 'vue'
import SwitchDealer from '@/components/dealer/SwitchDealer'
import { useStore } from 'vuex'
import { checkDealerJoin } from '@/api/plan'
import { getDefaultDealer } from '@/api/tyre'
import { getDistance } from '@/util'
import { useRoute } from 'vue-router'
import { showToast } from '@/util/couponCollection'
export default {
  components: {
    SwitchDealer
  },
  props: ['from', 'isOtrOrderNo', 'isShowPhone', 'updataDealer', 'colLabelSpan'],
  emits: ['setLoading'],
  setup(props, { emit }) {
    const mountEle = document.createElement('div')
    mountEle.id = 'dialog'
    document.body.appendChild(mountEle)
    onUnmounted(() => {
      // 清空节点
      document.body.removeChild(mountEle)
    })
    let { from, isOtrOrderNo, isShowPhone, updataDealer, colLabelSpan } = toRefs(props)
    let route = useRoute()
    const store = useStore()
    let { loyaltyType } = store.state.currentGoodsInfo
    let { loyaltyId = '' } = store.state
    let dealerJoinPlanFlag = store.state.dealerJoinPlanFlag
    let loyaltyDealerInfo = store.state.loyaltyDealerInfo
    let { gsCode: gscode } = route.query
    let gsCode = gscode || loyaltyDealerInfo.gs_code
    const state = reactive({
      gsCode,
      loyaltyType: loyaltyType,
      showNum: 0,
      isOtrOrderNo,
      from,
      isShowPhone,
      updataDealer,
      colLabelSpan,
      dealer: store.state.dealerInfo || {},
      dealerJoinPlanFlag: dealerJoinPlanFlag,
      joinCouponFlag: false,
      dealerFreezeFlag: false
    })
    const colLabelSpanCom = computed(() => (state.colLabelSpan ? state.colLabelSpan : 6))
    const colValSpan = computed(() => 24 - colLabelSpanCom.value)
    const changeShowNUm = () => {
      if (state.isOtrOrderNo) return false
      if (state.dealerFreezeFlag) return
      state.showNum += 1
    }
    const dealerFn = val => {
      state.dealer = val
      state.hasDealer = true
    }
    const getLoyaltyDealer = async () => {
      let loyaltyDealerInfo = store.state.loyaltyDealerInfo
      let { loyaltyId: productId, gsCode: gscode, from } = route.query
      let gsCode = gscode || loyaltyDealerInfo.gs_code
      let { lat: latitude, lng: longitude } = store.state.position
      let dealer = loyaltyDealerInfo
      console.log(gsCode, loyaltyId)
      if (!gsCode) {
        dealer = await getDefaultDealer({
          latitude,
          longitude,
          productId,
          productType: 1
        })
        gsCode = dealer.gsCode
      }
      if (!loyaltyId) return
      const isScan = from === 'scan' || from === 'QRcode'
      // 扫描且带经销商过来，走详情页逻辑
      // if (isScan && gscode) return
      if (!gsCode) return
      console.log('dealer----', dealer)
      if ((!dealer || !dealer.gsCode) && !gsCode && (!latitude || !longitude)) {
        store.dispatch('setLoyaltyDealerInfo', {})
        showToast('无法定位所在地点，请手动选择经销商后查看相关信息')
      }
      let checkresult = await checkDealerJoin({
        loyaltyId,
        gsCode,
        latitude,
        longitude
      })
      emit('setLoading', false)
      if (typeof checkresult.distance === 'number') {
        dealer.distance = getDistance(checkresult.distance)
      }
      dealer.joinPlanFlag = !!checkresult.joinPlanFlag
      let _gsCode = dealer.gs_code || dealer.gsCode
      state.gsCode = _gsCode
      dealer.gs_code = dealer.gsCode = _gsCode
      store.dispatch('setLoyaltyDealerInfo', { ...store.state.dealerInfo, ...dealer })
      state.dealer.joinPlanFlag = state.dealerJoinPlanFlag = !!checkresult.joinPlanFlag
      store.dispatch('setDealerJoinPlanFlag', !!checkresult.joinPlanFlag)
      // state.dealer=dealer
    }

    onMounted(() => {
      if (state.from === 'coupon') {
        store.commit('SETLOYALTYID', '')
      } else if (state.from !== 'tyre') {
        getLoyaltyDealer()
      }
    })
    watch(
      () => store.state.dealerJoinPlanFlag,
      n => {
        state.dealerJoinPlanFlag = n
      }
    )
    watch(
      () => store.state.dealerFreezeFlag,
      n => {
        state.dealerFreezeFlag = n || false
      },
      { immediate: true }
    )
    watch(
      () => store.state.joinCouponFlag,
      n => {
        state.joinCouponFlag = n
        if (state.from === 'coupon') {
          let dealerInfo = store.state.loyaltyDealerInfo || {}
          store.dispatch('setLoyaltyDealerInfo', { ...dealerInfo, joinCouponFlag: n })
        }
      },
      { immediate: true }
    )
    watch(
      () => state.updataDealer,
      () => {
        state.dealer = store.state.dealerInfo
      }
    )
    watch(
      () => state.gsCode,
      n => {
        if (n) {
          getLoyaltyDealer()
        }
      }
    )
    watch(
      () => store.state.dealerInfo,
      n => {
        state.dealer = n
      }
    )
    return {
      ...toRefs(state),
      dealerFn,
      colLabelSpanCom,
      colValSpan,
      changeShowNUm
    }
  }
}
</script>

<style lang="scss" scoped>
.dealerInfoBox {
  margin-bottom: 14px;
}
.colLabel {
  font-size: 14px;
  color: #333;
  // line-height: 30px;
  font-weight: bold;
}

.circle {
  padding: 1px 8px;
  margin-right: 16px;
  border: 1px solid#666;
  border-radius: 5px;
  font-size: 12px;
}
.circleActive {
  border-color: rgb(48, 136, 197);
  color: rgb(48, 136, 197);
}
.dealerLocation {
  margin: 10px 0;
  font-size: 13px;
  color: #666;
  line-height: 18px;
}
.phone {
  font-size: 24px;
  color: #3088c5;
  transform: rotate(-90deg);
}

.dealerName {
  font-size: 14px;
  color: #333;
  font-weight: 700;
}
.noDealer {
  font-size: 14px;
  color: #999999;
}
.dealerLocationBox {
  width: calc(100% - 40px);
  font-size: 13px;
  i {
    font-size: 50px;
  }
}
.salesVolume {
  font-size: 13px;
  color: #3088c5;
}
</style>
